
    import "src/app/AppSeller/Orders/ManualOrder/Components/OtherDetails/index.module.scss?farm_css_modules";
    
    export default {}
    